<template>
    <transition name="fade">
        <div>
            <p class="sign-up-subtitle">{{$t('completed_profile')}}</p>
            <el-form :model="formData" :rules="formRules" ref="formRef" @submit.native.prevent>
                <el-form-item prop="firstName">
                    <el-input v-model="formData.firstName" :placeholder="$t('first_name')"></el-input>
                </el-form-item>
                <input type="text" style="display:none;" />
                <input type="password" style="display:none;" />
                <el-form-item prop="lastName">
                    <el-input v-model="formData.lastName" :placeholder="$t('last_name')"></el-input>
                </el-form-item>
                <button class="form-btn" @click="confirm">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                firstName: "",
                lastName: ""
            },
            formRules: {
                firstName: [
                    {
                        required: true,
                        message: this.$t("first_name_error"),
                        trigger: "none"
                    }
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t("last_name_error"),
                        trigger: "none"
                    }
                ]
            }
        };
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                let countryDetails = this.$local.get("seacrh_country");
                this.$req
                    .post("upuserexinfo", {
                        first_name: this.formData.firstName,
                        last_name: this.formData.lastName,
                        country: this.data.country,
                        sex: this.data.sex,
                        birthday: this.data.birthday,
                        country_id: countryDetails.country_id
                    })
                    .then(({ data }) => {
                        if (data.code === "2000") {
                            //修改登录状态
                            let user = this.$local.get("user");
                            user.user_info.first_name = this.formData.firstName;
                            user.user_info.last_name = this.formData.lastName;
                            this.$store.dispatch("updateUser", user);

                            this.resetFields();
                            this.$store.dispatch("toggleShowSignup", false);
                            this.$emit("showInfo");
                        } else {
                            this.$msg.error(data.msg);
                        }
                    });
            });
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Public/SignUp/Info.vue